export default __webpack_public_path__ + "static/media/send-white.6916d6c8.svg";